export enum TimeOffTimeCategory {
  Upcoming = 'UPCOMING',
  Past = 'PAST',
}
